import { Injectable, signal } from '@angular/core';

export type Role = 'SUPER_ADMIN' | 'ADMIN' | 'USER';

@Injectable({ providedIn: 'root' })
export class AuthService {
  private readonly TOKEN_KEY = 'spotil_token';
  private readonly USER_KEY = 'spotil_user';
  private readonly ROLE_KEY = 'spotil_role';
  private readonly STORE_ID_KEY = 'spotil_store_id';
  private readonly IMAGE_KEY = 'spotil_user_image';

  loggedIn = signal(false);
  userName = signal('');
  userImage = signal('');
  role = signal<Role | null>(null);
  storeId = signal<string | null>(null);

  constructor() {
    const token = localStorage.getItem(this.TOKEN_KEY);
    const user = localStorage.getItem(this.USER_KEY);
    const role = localStorage.getItem(this.ROLE_KEY) as Role | null;
    const storeId = localStorage.getItem(this.STORE_ID_KEY);
    const image = localStorage.getItem(this.IMAGE_KEY);
    this.loggedIn.set(!!token);
    this.userName.set(user || '');
    this.userImage.set(image || '');
    this.role.set(role);
    this.storeId.set(storeId);
  }

  login(token: string, user: string, role: Role, storeId: string | null): void {
    localStorage.setItem(this.TOKEN_KEY, token);
    localStorage.setItem(this.USER_KEY, user);
    localStorage.setItem(this.ROLE_KEY, role);
    if (storeId) localStorage.setItem(this.STORE_ID_KEY, storeId);
    else localStorage.removeItem(this.STORE_ID_KEY);
    this.loggedIn.set(true);
    this.userName.set(user);
    this.role.set(role);
    this.storeId.set(storeId);
  }

  setImage(url: string): void {
    localStorage.setItem(this.IMAGE_KEY, url);
    this.userImage.set(url);
  }

  logout(): void {
    localStorage.removeItem(this.TOKEN_KEY);
    localStorage.removeItem(this.USER_KEY);
    localStorage.removeItem(this.ROLE_KEY);
    localStorage.removeItem(this.STORE_ID_KEY);
    localStorage.removeItem(this.IMAGE_KEY);
    this.loggedIn.set(false);
    this.userName.set('');
    this.userImage.set('');
    this.role.set(null);
    this.storeId.set(null);
  }

  isAdminOrAbove(): boolean {
    const r = this.role();
    return r === 'ADMIN' || r === 'SUPER_ADMIN';
  }

  isSuperAdmin(): boolean {
    return this.role() === 'SUPER_ADMIN';
  }
}
